export default __webpack_public_path__ + "static/media/293.56268e1b.jpg";